import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'
import './style.css'
import Home from './views/home'
import Rules from './views/rules'
import NotFound from './views/notfound'

const App = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path="/" component={Home} />
      <Route exact path="/rules" component={Rules} />
      <Route path="/404" component={NotFound} />
      <Redirect to="/404" />
    </Switch>
  </BrowserRouter>
)

ReactDOM.render(<App />, document.getElementById('root'))
